import MuiMenuItem, { MenuItemProps } from '@mui/material/MenuItem'
import { Link } from '../Link'

export default function MenuItem(props: MenuItemProps & { href?: string }) {
    if (props.href) {
        return <MuiMenuItem {...props} component={Link as any} />
    }
    return <MuiMenuItem {...props} />
}
